import { Icon } from "@circle-react-shared/Icon";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";
import { Typography } from "@/react/components/SettingsApp/CompassCompat/Typography";
import { classNames } from "@/react/helpers/twMergeWithCN";

import type { ConnectionButtonSize } from "../types";
import type { ConnectIconButtonsProps } from "./ConnectIconButtons";

const sizeClasses = {
  sm: "!h-7 !px-3",
  md: "!h-8 !px-4",
  lg: "!h-10 !px-5",
  full: "w-full",
};

export interface ConnectUiKitButtonsProps extends ConnectIconButtonsProps {
  size?: ConnectionButtonSize;
}

export const ConnectUiKitButtons = ({
  className,
  flexDirection,
  handleAccept,
  handleIgnore,
  isAccepting,
  isIgnoring,
  size = "md",
}: ConnectUiKitButtonsProps) => {
  const isLoading = isIgnoring || isAccepting;
  return (
    <div className={classNames("flex gap-2 w-fit", flexDirection, className)}>
      <Button
        variant="circle"
        onClick={handleAccept}
        disabled={isLoading}
        aria-label={t("member_directory.accept")}
        data-testid="accept-button"
        large={size === "lg"}
        className={classNames(
          "!border-primary !font-medium flex justify-center items-center !gap-1",
          sizeClasses[size],
          className,
        )}
      >
        {isAccepting ? (
          <Icon type="loader" />
        ) : (
          <Typography.LabelSm color="text-lighter" weight="font-medium">
            {t("member_directory.accept")}
          </Typography.LabelSm>
        )}
      </Button>
      <Button
        variant="secondary"
        onClick={handleIgnore}
        disabled={isLoading}
        aria-label={t("member_directory.ignore")}
        data-testid="ignore-button"
        large={size === "lg"}
        className={classNames(
          "!border-primary !font-medium flex justify-center items-center !gap-1",
          sizeClasses[size],
          className,
        )}
      >
        {isIgnoring ? (
          <Icon type="loader" />
        ) : (
          <Typography.LabelSm color="text-primary" weight="font-medium">
            {t("member_directory.ignore")}
          </Typography.LabelSm>
        )}
      </Button>
    </div>
  );
};
